import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'item', 'empty'];

  connect() {
    this.filters = [this.defaultTextFilter];

    this.mutationObserver = new MutationObserver(() => this.filter());
    this.mutationObserver.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    this.mutationObserver?.disconnect();
  }

  addFilters(...filters) {
    this.filters.push(...filters);
  }

  filter() {
    const term = this.inputTarget.value.toLowerCase().trim();
    let anyVisible = false;

    this.itemTargets.forEach((el) => {
      const visible = this.filters.every((fn) => fn.call(this, { el, term }));

      el.classList.toggle('hidden', !visible);
      if (visible) anyVisible = true;
    });

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle('hidden', anyVisible);
    this.markActiveMatch();
  }

  // Optional: mark (e.g. via a CSS class) the item that activateFirstVisible
  // would activate, so it's clear which one Enter would pick while typing.
  markActiveMatch() {
    const match = this.firstVisibleItem();
    this.itemTargets.forEach((el) => el.classList.toggle('is-active-match', el === match));
  }

  clearActiveMatch() {
    this.itemTargets.forEach((el) => el.classList.remove('is-active-match'));
  }

  // Optional: bind to keydown.enter on the input to activate (click) the
  // first visible, enabled item — e.g. to switch to the top search match.
  activateFirstVisible(event) {
    event.preventDefault();
    this.firstVisibleItem()?.click();
  }

  firstVisibleItem() {
    return this.itemTargets.find((el) => !el.disabled && !el.classList.contains('hidden'));
  }

  defaultTextFilter({ el, term }) {
    if (!term) return true;
    return el.innerText.toLowerCase().includes(term);
  }
}
